module.exports = __webpack_public_path__ + "img/湖南大学.412b6702.png";